export const CONFIG = {
  cognito: {
    REGION: 'ap-northeast-1',
    USER_POOL_ID: 'ap-northeast-1_1ACiUyF1H',
    APP_CLIENT_ID: '1rt35ctopf84fbh47lllf0gg5k'
  },
  apiGateway: {
    REGION: 'ap-northeast-1',
    URL: 'https://cqto1p9g0j.execute-api.ap-northeast-1.amazonaws.com',
    ENV: 'prod'
  }
}
